import { render, staticRenderFns } from "./ExportCard.vue?vue&type=template&id=1f0c2e76&scoped=true&"
import script from "./ExportCard.vue?vue&type=script&lang=js&"
export * from "./ExportCard.vue?vue&type=script&lang=js&"
import style0 from "./ExportCard.vue?vue&type=style&index=0&id=1f0c2e76&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f0c2e76",
  null
  
)

export default component.exports